import React from "react";
import { Link } from "react-router-dom";
import "../../css/home.css";
import {
  sarees,
  churidar,
  kurtis,
  shorttops,
  tshirtwomens,
  bottoms_womens,
  nightwears,
  kids,
} from "../../assets";

const categoryTiles = [
  { key: "half-hand", label: "Sarees", link: "/all-product?subCategory=Saree", image: sarees },
  { key: "oversized", label: "Kurtis", link: "/all-product?subCategory=Kurti", image: kurtis },
  { key: "winterwear", label: "Churidar sets", link: "/all-product?subCategory=Churidar+Set", image: churidar },
  { key: "jeans", label: "Short tops", link: "/all-product?subCategory=Short+Tops", image: shorttops },
  { key: "cargos", label: "T-shirts", link: "/all-product?subCategory=T-Shirt", image: tshirtwomens },
  { key: "polos", label: "Bottoms", link: "/all-product?subCategory=Bottoms", image: bottoms_womens },
  { key: "joggers", label: "Nightwear", link: "/all-product?subCategory=Nightwears", image: nightwears },
  { key: "trousers", label: "Kids", link: "/all-product?category=KIDS", image: kids },
];

const CategoryStrip = () => {
  return (
    <section className="m-section m-categories">
      <div className="m-section-head m-section-head--center">
        <div>
          <h2 className="m-section-title">Shop by category</h2>
        </div>
      </div>

      <div className="m-arch-row">
        {categoryTiles.map((tile) => (
          <Link key={tile.key} to={tile.link} className="m-arch">
            <span className="m-arch-frame">
              <img src={tile.image} alt="" loading="lazy" />
            </span>
            <span className="m-arch-label">{tile.label}</span>
          </Link>
        ))}
      </div>

      {/* Quick filters straight from the home page */}
      <nav className="m-quick-filters" aria-label="Quick filters">
        <span>Shop by price</span>
        <Link to="/all-product?maxPrice=499">Under ₹499</Link>
        <Link to="/all-product?maxPrice=999">Under ₹999</Link>
        <Link to="/all-product?maxPrice=1999">Under ₹1,999</Link>
        <Link to="/all-product?minPrice=2000">₹2,000 and above</Link>
        <Link to="/all-product" className="m-quick-all">All filters</Link>
      </nav>
    </section>
  );
};

export default CategoryStrip;
